// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".policy-text[data-v-1b60d9db]{max-height:300px;overflow-y:auto}.title-left[data-v-1b60d9db]{display:flex;flex:1;align-items:center}", ""]);
// Exports
module.exports = exports;
